import React, { Component } from "react";
import ApiConnect from "../../../Utils/ApiConnect";
import { Scrollbars } from "react-custom-scrollbars-2";
import { connect } from "react-redux";
import {
  PlaceTableOrder,
  RefreshTable,
  CheckoutCurrentCart,
  SetCartToDefault,
} from "../../../redux/actions/Cart.Action";
import { toast } from "react-toastify";
import Checkout from "./Checkout";

import { Modal } from "react-bootstrap";
import CurrentCartData from "../../Components/Cart/CurrentCartData";
import DiscountTotal from "../../Components/Cart/DiscountTotal";
import CartHeader from "../../Components/Cart/CartHeader";
import ReactToPrint from "react-to-print";
import { ReceiptPrint } from "../Print/ReceiptPrint";
import { BarCodeProduct } from "../../../redux/actions/Product.Action";
import BarcodeScanner from "../../Components/BarcodeScanner";
export class TableCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartData: [],
      show: false,
      PrintModal: false,
      emailModal: false,
      smsModal: false,
      invoice: false,
      smsContact: false,
      customerEmail: false,
      btnDisable: false,
    };
  }
  handleModalClose = () => {
    this.setState({ show: false });
  };
  PlaceOrder = () => {
    if (this.props.CurrentCart.length !== 0) {
      this.props.PlaceTableOrder();
    } else {
      toast.error("Please select the table", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
    }
  };
  CloseTable(orderid, table) {
    ApiConnect.delete(
      `POS/Inventory/CloseTable?orderid=${orderid}&table=${table}`
    )
      .then((response) => {
        if (response.data.status === 200) {
          toast.error(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.props.RefreshTable();
        } else {
          toast.warning(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  PrintPrompt = (data = false) => {
    this.setState({ PrintModal: true, show: false, invoice: data });
  };
  ClosePrintPrompt = () => {
    this.setState({
      show: false,
      PrintModal: false,
      emailModal: false,
      smsModal: false,
      invoice: false,
      smsContact: false,
      customerEmail: false,
      btnDisable: false,
    });
    this.props.SetCartToDefault();
  };
  onSubmitSMS = (e) => {
    e.preventDefault();
    console.log(this.state.smsContact);
    this.setState({ btnDisable: true });
    const Fdata = new FormData();
    Fdata.append("id", this.state.invoice);
    Fdata.append("contact", this.state.smsContact);
    ApiConnect({
      method: "post",
      url: "/POS/Checkout/SendSMS",
      data: Fdata,
    })
      .then((response) => {
        if (response) {
          toast.success("Message Send", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({ smsModal: false });
        } else if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else {
          toast.error(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };

  onSubmitMail = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    const Fdata = new FormData();
    Fdata.append("id", this.state.invoice);
    Fdata.append("contact", this.state.mailAddress);
    ApiConnect({
      method: "post",
      url: "/POS/Checkout/SendMail",
      data: Fdata,
    })
      .then((response) => {
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({ emailModal: false });
        } else if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else {
          toast.error(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };

  handelBarCode = (e) => {
    this.props.BarCodeProduct(e)
  }

  render() {
    const CurrentCart = this.props.CurrentCart;
    const wid = "80mm";
    const InvoiceCss = `
 @page {
    size : ${wid} 295mm;
    margin : 0; 
  }

  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
caption,
th,
td {
  text-align: left;
  font-weight: normal;
}
p {
  padding-bottom: 5px;
  font-size: 16px;
}
.company-name {
  font-weight: 600;
  padding-top: 5px;
  font-size: 21px; 
}
.bill {
  padding-top: 12px;
  letter-spacing: 2px;
}

.text-right {
  text-align: right;
}  
.text-center {
  text-align: center;
}
.m-0{
  margin:;0;
}
.p-0{
  padding:0;
}
`;
    return (
      <aside className="col-md-4 h-100  p-0 overflow-hidden">
        <div className="card">
          <CartHeader POS={true} />
          <BarcodeScanner fallback={this.handelBarCode} />
          <Scrollbars style={{ height: "calc(100vh - 40ex)" }}>

            <CurrentCartData POS={true} />
          </Scrollbars>
          <DiscountTotal POS={true} />
          <div className="d-flex h-80px col-4 w-100">
            <button
              className="btn btn-danger btn-lg h-20 w-50"
              disabled={
                CurrentCart.order && CurrentCart.order.length > 0 ? true : false
              }
              onClick={() =>
                this.CloseTable(CurrentCart.order_id, CurrentCart.table)
              }
            >
              Cancel
            </button>
            <button
              className="btn btn-info btn-lg h-20 w-100"
              disabled={CurrentCart.order ? false : true}
              onClick={() => this.PlaceOrder()}
            >
              Place Order
            </button>
            <button
              className="btn btn-success btn-lg h-20 w-100"
              disabled={CurrentCart.order ? false : true}
              onClick={(e) => {
                this.setState({ show: true });
              }}
            >
              Pay
            </button>
          </div>
          <Modal
            show={this.state.show}
            centered
            size="lg"
            scrollable={true}
            onHide={() => this.handleModalClose()}
          >
            <Modal.Body className="p-0 pb-2">
              <Checkout closeToggle={this.handleModalClose} />
            </Modal.Body>
            <Modal.Footer className="p-0">
              <button
                className="col w-100 btn btn-danger btn-multiline btn btn-w-lg align-self-center p-25 fs-30"
                onClick={() => this.handleModalClose()}
              >
                Cancel
              </button>
              <button
                className="col w-100 btn btn-success btn-multiline btn btn-w-lg  align-self-center p-25 fs-30"
                onClick={() =>
                  this.props.CheckoutCurrentCart(
                    this.PrintPrompt,
                    this.state.customerContact,
                    this.state.customerEmail
                  )
                }
              >
                Checkout
              </button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.PrintModal}
            centered
            size="lg"
            scrollable={true}
            onHide={() => this.ClosePrintPrompt()}
          >
            <Modal.Body className="p-0 pb-2">
              <div className="container">
                <ReceiptPrint
                  ref={(el) => (this.componentRef = el)}
                  Userchange={this.state.change}
                  UsercashIn={this.state.cashin}
                  CurrentCartOrder={this.props.CurrentCartOrder}
                  CurrentCart={this.props.CurrentCart || []}
                  CompanyInfo={this.props.CompanyInfo}
                />
              </div>
            </Modal.Body>
            <Modal.Footer className="p-0">
              <button
                className="col w-100 btn btn-primary btn-multiline btn btn-w-lg align-self-center p-20"
                onClick={(e) => {
                  this.setState({ emailModal: true });
                }}
              >
                <span className="material-icons-outlined fs-35">
                  forward_to_inbox
                </span>
                <br />
                Mail
              </button>
              <button
                className="col w-100 btn btn-info btn-multiline btn btn-w-lg align-self-center p-20"
                onClick={(e) => {
                  this.setState({ smsModal: true });
                }}
              >
                <span className="material-icons-outlined fs-35">textsms</span>
                <br />
                SMS
              </button>
              <ReactToPrint
                documentTitle={
                  this.props.CurrentCart.order_id + this.props.CurrentCart.table
                }
                pageStyle={InvoiceCss}
                copyStyles={false}
                trigger={() => {
                  return (
                    <button className="col w-100 btn btn-warning btn-multiline btn btn-w-lg align-self-center p-20">
                      <span className="material-icons-outlined fs-35">
                        print
                      </span>
                      <br />
                      Print
                    </button>
                  );
                }}
                content={() => this.componentRef}
              />
              <button
                className="col w-100 btn btn-success btn-multiline btn btn-w-lg  align-self-center p-20"
                onClick={() => this.ClosePrintPrompt()}
              >
                <span className="material-icons-outlined fs-35">verified</span>
                <br />
                Complete
              </button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.smsModal}
            className="modal fade bg-theme "
            onHide={() => this.setState({ smsModal: false })}
          >
            <Modal.Header className="mb-0 pb-0">
              <h5 className="modal-title">Send SMS Invoice</h5>
              <button
                type="button"
                className="btn"
                onClick={() => this.setState({ smsModal: false })}
              >
                <span>×</span>
              </button>
            </Modal.Header>
            <Modal.Body className="p-0">
              <div className="container pb-10">
                <form onSubmit={(e) => this.onSubmitSMS(e)}>
                  <div className="form-group">
                    <label className="text-dark">Customer Contact</label>
                    <input
                      className="form-control"
                      type="number"
                      required={true}
                      pattern="[0-9]{10}"
                      maxlength="10"
                      value={this.state.smsContact}
                      onChange={(e) =>
                        this.setState({ smsContact: e.target.value })
                      }
                      placeholder="1234567890"
                    />
                    <br />
                    <button type="submit" className="w-100 btn btn-primary">
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={this.state.emailModal}
            className="modal fade bg-theme "
            onHide={() => this.setState({ emailModal: false })}
          >
            <Modal.Header className="mb-0 pb-0">
              <h5 className="modal-title">Send Mail Invoice</h5>
              <button
                type="button"
                className="btn"
                onClick={() => this.setState({ emailModal: false })}
              >
                <span>×</span>
              </button>
            </Modal.Header>
            <Modal.Body className="p-0">
              <div className="container pb-10">
                <form onSubmit={(e) => this.onSubmitMail(e)}>
                  <div className="form-group">
                    <label className="text-dark">Customer Email</label>
                    <input
                      className="form-control"
                      type="email"
                      placeholder="example@example.com"
                      value={this.state.customerEmail}
                      required={true}
                      onChange={(e) =>
                        this.setState({ customerEmail: e.target.value })
                      }
                    />
                    <br />
                    <button type="submit" className="w-100 btn btn-primary">
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </aside>
    );
  }
}

export default connect(
  (state) => ({
    CurrentCart: state.Cart.CurrentCart,
    CurrentCartOrder: state.Cart.CurrentCart.order,
    CompanyInfo: state.Auth.company,
  }),
  { SetCartToDefault, CheckoutCurrentCart, PlaceTableOrder, RefreshTable, BarCodeProduct }
)(TableCart);
